// DO NOT EDIT -- generated from fs/services/pie/pie.proto

import * as funnelmetrics from '../../api/metrics/funnelmetrics';
import * as metrics from '../../api/metrics';
import * as proactiveinsights from '../../api/proactiveinsights';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace InsightsServicePublic {

  export const GetInsightsEndpoint = "/grpc/pie.InsightsServicePublic/GetInsights";
  /** GetInsights returns insights generated on dx-objects, such as metric insights */
  export function GetInsights(sender: (req: GetInsightsRequest, endpoint: string) => Promise<GetInsightsResponse>, req: GetInsightsRequest): { promise: () => Promise<GetInsightsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInsightsEndpoint),
      endpoint: GetInsightsEndpoint
    };
  }

  export const GetAlertsEndpoint = "/grpc/pie.InsightsServicePublic/GetAlerts";
  /** GetAlerts returns instances of alerts that have been triggered, i.e. a metric alert threshold that has been crossed */
  export function GetAlerts(sender: (req: GetAlertsRequest, endpoint: string) => Promise<GetAlertsResponse>, req: GetAlertsRequest): { promise: () => Promise<GetAlertsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAlertsEndpoint),
      endpoint: GetAlertsEndpoint
    };
  }

  export const GetLastInsightsEndpoint = "/grpc/pie.InsightsServicePublic/GetLastInsights";
  /**
   * GetLastInsight returns the most recent insights given an orgId and alert config ids
   * returned map contains all insights passed, with nil values if there are no insights present
   */
  export function GetLastInsights(sender: (req: GetLastInsightsRequest, endpoint: string) => Promise<GetLastInsightsResponse>, req: GetLastInsightsRequest): { promise: () => Promise<GetLastInsightsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetLastInsightsEndpoint),
      endpoint: GetLastInsightsEndpoint
    };
  }
}

export namespace DataIngestionService {

  export const SetInsightMetricDataEndpoint = "/grpc/pie.DataIngestionService/SetInsightMetricData";
  /** SetInsightMetricData adds or loads a new event metric data into the ingestion service. */
  export function SetInsightMetricData(sender: (req: SetInsightMetricDataRequest, endpoint: string) => Promise<{}>, req: SetInsightMetricDataRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetInsightMetricDataEndpoint),
      endpoint: SetInsightMetricDataEndpoint
    };
  }

  export const SetInsightFunnelMetricDataEndpoint = "/grpc/pie.DataIngestionService/SetInsightFunnelMetricData";
  /** SetInsightFunnelMetricData adds or loads a new event funnel data into the ingestion service. */
  export function SetInsightFunnelMetricData(sender: (req: SetInsightFunnelMetricDataRequest, endpoint: string) => Promise<{}>, req: SetInsightFunnelMetricDataRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetInsightFunnelMetricDataEndpoint),
      endpoint: SetInsightFunnelMetricDataEndpoint
    };
  }
}

export namespace ReadDXDataService {

  export const GetDXInputDataEndpoint = "/grpc/pie.ReadDXDataService/GetDXInputData";
  /**
   * GetDXInputData returns the DXInputData we have stored, by DXInputData id.
   * If no DXInputData with that ID is found, it returns an error.
   */
  export function GetDXInputData(sender: (req: GetDXInputDataRequest, endpoint: string) => Promise<GetDXInputDataResponse>, req: GetDXInputDataRequest): { promise: () => Promise<GetDXInputDataResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDXInputDataEndpoint),
      endpoint: GetDXInputDataEndpoint
    };
  }

  export const GetDXInputDataByComputationsEndpoint = "/grpc/pie.ReadDXDataService/GetDXInputDataByComputations";
  /**
   * GetDXInputDataByComputation returns the DXInputData we have stored, by computations for a given OrgID and timezone.
   * If no DXInputData with that ID is found, it returns an error with status code not found.
   */
  export function GetDXInputDataByComputations(sender: (req: GetDXInputDataByComputationsRequest, endpoint: string) => Promise<GetDXInputDataByComputationsResponse>, req: GetDXInputDataByComputationsRequest): { promise: () => Promise<GetDXInputDataByComputationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDXInputDataByComputationsEndpoint),
      endpoint: GetDXInputDataByComputationsEndpoint
    };
  }
}

export namespace MetricIgnoreListService {

  export const GetIgnoredMetricIdsEndpoint = "/grpc/pie.MetricIgnoreListService/GetIgnoredMetricIds";
  export function GetIgnoredMetricIds(sender: (req: GetIgnoredMetricIdsRequest, endpoint: string) => Promise<GetIgnoredMetricIdsResponse>, req: GetIgnoredMetricIdsRequest): { promise: () => Promise<GetIgnoredMetricIdsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIgnoredMetricIdsEndpoint),
      endpoint: GetIgnoredMetricIdsEndpoint
    };
  }

  export const SetIgnoredMetricIdEndpoint = "/grpc/pie.MetricIgnoreListService/SetIgnoredMetricId";
  export function SetIgnoredMetricId(sender: (req: SetIgnoredMetricIdRequest, endpoint: string) => Promise<{}>, req: SetIgnoredMetricIdRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetIgnoredMetricIdEndpoint),
      endpoint: SetIgnoredMetricIdEndpoint
    };
  }

  export const DeleteIgnoredMetricIdEndpoint = "/grpc/pie.MetricIgnoreListService/DeleteIgnoredMetricId";
  export function DeleteIgnoredMetricId(sender: (req: DeleteIgnoredMetricIdRequest, endpoint: string) => Promise<{}>, req: DeleteIgnoredMetricIdRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteIgnoredMetricIdEndpoint),
      endpoint: DeleteIgnoredMetricIdEndpoint
    };
  }

  export const GetDataPointLimitsEndpoint = "/grpc/pie.MetricIgnoreListService/GetDataPointLimits";
  export function GetDataPointLimits(sender: (req: GetDataPointLimitsRequest, endpoint: string) => Promise<GetDataPointLimitsResponse>, req: GetDataPointLimitsRequest): { promise: () => Promise<GetDataPointLimitsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDataPointLimitsEndpoint),
      endpoint: GetDataPointLimitsEndpoint
    };
  }

  export const SetDataPointLimitForMetricIdEndpoint = "/grpc/pie.MetricIgnoreListService/SetDataPointLimitForMetricId";
  export function SetDataPointLimitForMetricId(sender: (req: SetDataPointLimitForMetricIdRequest, endpoint: string) => Promise<{}>, req: SetDataPointLimitForMetricIdRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SetDataPointLimitForMetricIdEndpoint),
      endpoint: SetDataPointLimitForMetricIdEndpoint
    };
  }

  export const DeleteDataPointLimitForMetricIdEndpoint = "/grpc/pie.MetricIgnoreListService/DeleteDataPointLimitForMetricId";
  export function DeleteDataPointLimitForMetricId(sender: (req: DeleteDataPointLimitForMetricIdRequest, endpoint: string) => Promise<{}>, req: DeleteDataPointLimitForMetricIdRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteDataPointLimitForMetricIdEndpoint),
      endpoint: DeleteDataPointLimitForMetricIdEndpoint
    };
  }
}

export namespace DataDeletionService {

  export const DeleteOrgEndpoint = "/grpc/pie.DataDeletionService/DeleteOrg";
  /** DeleteOrg deletes all data that pie has stored for a given org. */
  export function DeleteOrg(sender: (req: DeleteOrgRequest, endpoint: string) => Promise<{}>, req: DeleteOrgRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteOrgEndpoint),
      endpoint: DeleteOrgEndpoint
    };
  }

  export const DeleteTimeRangeEndpoint = "/grpc/pie.DataDeletionService/DeleteTimeRange";
  /** DeleteTimeRange deletes all data for an org between a start and end time. */
  export function DeleteTimeRange(sender: (req: DeleteTimeRangeRequest, endpoint: string) => Promise<{}>, req: DeleteTimeRangeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteTimeRangeEndpoint),
      endpoint: DeleteTimeRangeEndpoint
    };
  }

  export const DeleteTrailingEdgeEndpoint = "/grpc/pie.DataDeletionService/DeleteTrailingEdge";
  /**
   * DeleteTrailingEdge deletes all data up to the cutoff timestamp, including the DX Input data stored in BigTable
   * and and Insights stored in Datastore.
   */
  export function DeleteTrailingEdge(sender: (req: DeleteTrailingEdgeRequest, endpoint: string) => Promise<{}>, req: DeleteTrailingEdgeRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteTrailingEdgeEndpoint),
      endpoint: DeleteTrailingEdgeEndpoint
    };
  }
}

export interface GetIgnoredMetricIdsRequest {
  orgId: string;
}

export interface GetIgnoredMetricIdsResponse {
  metricIds: string[];
}

export interface SetIgnoredMetricIdRequest {
  orgId: string;
  metricId: string;
}

export interface DeleteIgnoredMetricIdRequest {
  orgId: string;
  metricId: string;
}

export interface GetDataPointLimitsRequest {
  orgId: string;
}

export interface GetDataPointLimitsResponse {
  limits: { [key: string]: number };
}

export interface SetDataPointLimitForMetricIdRequest {
  orgId: string;
  metricId: string;
  dataPointLimit: number;
}

export interface DeleteDataPointLimitForMetricIdRequest {
  orgId: string;
  metricId: string;
}

export interface GetInsightsRequest {
  orgId: string;
  /**
   * optional, will filter on Id/Version/Object Type if any of them are set. For example, if Id is set but not version,
   * then it will return any insights with that object (and any version). If none are set, will return all insights for
   * the org.
   */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
  /** optional, if set then will only return insights that were created after the provided time */
  after: protobuf.timestamp | null;
}

export interface GetInsightsResponse {
  insights: proactiveinsights.Insight[];
}

export interface GetAlertsRequest {
  orgId: string;
  /** required, the alert config id to fetch alert triggered instances for */
  alertConfigId: string;
}

export interface GetAlertsResponse {
  alerts: proactiveinsights.Insight[];
}

export interface GetLastInsightsRequest {
  orgId: string;
  alertId: string[];
}

export interface GetLastInsightsResponse {
  insightsByAlertId: { [key: string]: proactiveinsights.Insight };
}

/** to ingest request and response of a metrics.ComputeMetric call */
export interface SetInsightMetricDataRequest {
  orgId: string;
  /**
   * the computations produced by directly translating the Metric definition to an Alexa compute request.
   * However, the metric Data Tables could potentially represent a different Time Range from the original computations.
   * For example, we may wish to retrieve just the leading data point or need to backfill some data.
   * We need the original computation since the computation hash is the key for storing the data. We want to store
   * all the data from different Time Range queries into the same table.
   */
  originalComps: metrics.Computation[];
  /** data tables corresponding to each computation */
  dataTables: metrics.DataTable[];
  /** the time at which the data was computed */
  dataComputedAt: protobuf.timestamp | null;
  /** data relating to the underlying data source */
  pieConsumptionData: proactiveinsights.PieConsumptionData | null;
  /** The time zone this computation was computed for */
  timeZone: string;
  /**
   * Pie's default behavior is to check whether the metric computation ends in NOW and, if so, trim the leading edge in
   * each metrics.DataTable, because the data point may be incomplete. If the caller knows that all data points are
   * complete, they can set this field to true to bypass that logic and save all data points to bigtable.
   */
  writeAllData: boolean;
  /** Only required for compare to past metrics */
  timeRangeComparison: visualizationsettings.TimeRangeComparison | null;
}

export interface SetInsightFunnelMetricDataRequest {
  orgId: string;
  /** funnel definition, includes user selected steps for trended funnels */
  funnelDefinition: search_settings.Funnel | null;
  /** the computation produced by directly translating the funnel definition to an Alexa compute request. */
  computations: funnelmetrics.Computation[];
  /** data tables corresponding to each computation */
  tables: funnelmetrics.FunnelDataTables[];
  /** id, version, and type of supported object (ie: funnel) */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
  /** the time at which the data was computed */
  dataComputedAt: protobuf.timestamp | null;
  /** The time zone this computation was computed for */
  timeZone: string;
  /**
   * Pie's default behavior is to check whether the computation ends in NOW and, if so, trim the leading edge in
   * each Data Table, because the data point may be incomplete. If the caller knows that all data points are
   * complete, they can set this field to true to bypass that logic and save all data points to bigtable.
   */
  writeAllData: boolean;
  /**
   * when manually back filling data we want pie to generate statistics after saving to big table
   * so this is passed in from the hermes BackfillProactiveFunnel request
   */
  generateInsight: boolean;
}

export interface DXInputDataID {
  orgId: string;
  computationKind: proactiveinsights.ComputationKind;
  requestHash: string;
}

export interface GetDXInputDataRequest {
  /** The id that uniquely identifies the metric computation data to be retrieved. */
  dxInputDataId: DXInputDataID | null;
  /**
   * The timezone to retrieve data for. For time intervals larger than an hour, the data will differ depending
   * on  what time zone we query for. Defaults to UTC if not set.
   */
  timezone: string;
  /**
   * Specifies whether the returned DXInputData object may contain gaps in its time series data. For example,
   * if pie has data stored for [3/12, 3/14, 3/15, 3/16] and has a gap in data at 3/13, if allow_gaps is set to false,
   * it will only return [3/14, 3/15, 3/16], but if allow_gaps is set to true it will return all data.
   */
  allowGaps: boolean;
}

export interface GetDXInputDataResponse {
  data: proactiveinsights.DXInputData | null;
}

export interface GetDXInputDataByComputationsRequest {
  orgId: string;
  computations: proactiveinsights.DXDataComputation[];
  /** defaults to UTC if not set */
  timezone: string;
  /**
   * Specifies whether the returned DXInputData object may contain gaps in its time series data. For example,
   * if pie has data stored for [3/12, 3/14, 3/15, 3/16] and has a gap in data at 3/13, if allow_gaps is set to false,
   * it will only return [3/14, 3/15, 3/16], but if allow_gaps is set to true it will return all data.
   */
  allowGaps: boolean;
}

export interface GetDXInputDataByComputationsResponse {
  data: proactiveinsights.DXInputData | null;
}

export interface DeleteOrgRequest {
  orgId: string;
}

export interface DeleteTimeRangeRequest {
  orgId: string;
  start: protobuf.timestamp | null;
  end: protobuf.timestamp | null;
  /**
   * When true, only delete "dimension" or "group-by" data, i.e. group-by funnel and metric data. Only dimension data
   * can have associated text with the data, for example a metric grouped by "Target Text" will contain the top "Target
   * Text" values for the metric. Non-dimension data is purely numerical data and has no text associated with it. For
   * segment deletions and redactions, we only delete dimension data, since non-dimension data has no risk of having
   * poisoned strings.
   */
  onlyDimensionData: boolean;
  /**
   * somewhat temporary of a fix. Currently we are over deleting dimensions for pie. We know there are some dimensions which
   * are probably safe to keep. This flag will allow us to skip deleting those metrics.
   */
  skipSafeSpotlightMetrics: boolean;
}

export interface DeleteTrailingEdgeRequest {
  orgId: string;
  /** The timestamp before which all data will be deleted from PIE Bigtable */
  cutoff: protobuf.timestamp | null;
}

export interface GenerateInsightData {
  dxInputDataId: DXInputDataID | null;
  /** Any Alert Configs associated with this insight generation request. */
  alertConfigs: proactiveinsights.AlertConfig[];
  /**
   * The time zone to fetch the DX Input Data from. If this is empty, the time zone that has the largest amount of
   * continuous recent data will be chosen.
   */
  timeZone: string;
  /** DxIdObject's version id should be read from the task as source of truth over the data in Bigtable */
  dxIdVersion: proactiveinsights.DxIdVersion | null;
  /**
   * the timestamp used for the metric computation, used to find the specific input data row.
   * this is necessary for backfilling past buckets
   */
  dataComputedAt: protobuf.timestamp | null;
}

/** NewInsightTask is the payload for the new-insight-queue, to notify subscribers that a new insight has been generated */
export interface NewInsightTask {
  orgId: string;
  insightId: string;
}
